import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

function Button(props) {
  const buildClasses = (props) => {
    let classList = [
      styles.button,
      props.theme,
      props.size
    ];

    return classList.join(' ');
  };

  return (
    props.href != null && props.href != '' ?
    <a {...props} data-testid="button-a" target="_blank" className={ buildClasses(props) }>
      {props.children}
    </a> :
    <button {...props} data-testid="button-button" className={ buildClasses(props) }>
      {props.children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.string,
  size: PropTypes.string,
  href: PropTypes.string,
};

Button.defaultProps = {
  theme: styles.buttonOrange,
  size: styles.buttonSizeMedium,
  href: null
};

Button.THEME = {
  ghostPrimary: styles.buttonGhostPrimary,
  gray: styles.buttonGray,
  orange: styles.buttonOrange,
  orangeAction: styles.buttonOrangeAction,
  outlinePrimary: styles.buttonOutlinePrimary,
  outlineRed: styles.buttonOutlineRed,
  solidPrimary: styles.buttonSolidPrimary,
  solidSecondary: styles.buttonSolidSecondary,
  text: styles.buttonText,
  white: styles.buttonWhite,
  whiteOutline: styles.buttonWhiteOutline,
};

Button.SIZE = {
  tiny: styles.buttonSizeTiny,
  small: styles.buttonSizeSmall,
  medium: styles.buttonSizeMedium,
  large: styles.buttonSizeLarge,
};

export default Button;
